export default {
  path: 'expenses',
  name: 'Expenses',
  component: () => import(/* webpackChunkName: "administration" */ '../views/ExpensesView.vue')
}
